/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Donatekey_Error1Inputs */

const id_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const ms_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat`)
};

const da_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl`)
};

const de_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const en_us2_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const es_es2_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const es_mx2_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fil_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const it_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

const hu_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba`)
};

const nl_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout`)
};

const no_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil`)
};

const pl_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd`)
};

const pt_br2_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const pt_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

const ro_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare`)
};

const fi_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe`)
};

const sv_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel`)
};

const vi_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi`)
};

const tr_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata`)
};

const cs_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba`)
};

const bg_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка`)
};

const ru_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const uk_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка`)
};

const ar_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ`)
};

const hi_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि`)
};

const th_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาด`)
};

const ja_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const zh_cn2_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const zh_hant1_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const ko_forms_donatekey_error1 = /** @type {(inputs: Forms_Donatekey_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Forms_Donatekey_Error1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_donatekey_error1 = /** @type {((inputs?: Forms_Donatekey_Error1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Donatekey_Error1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_donatekey_error1(inputs)
	if (locale === "ms") return ms_forms_donatekey_error1(inputs)
	if (locale === "da") return da_forms_donatekey_error1(inputs)
	if (locale === "de") return de_forms_donatekey_error1(inputs)
	if (locale === "en-US") return en_us2_forms_donatekey_error1(inputs)
	if (locale === "es-ES") return es_es2_forms_donatekey_error1(inputs)
	if (locale === "es-MX") return es_mx2_forms_donatekey_error1(inputs)
	if (locale === "fil") return fil_forms_donatekey_error1(inputs)
	if (locale === "fr") return fr_forms_donatekey_error1(inputs)
	if (locale === "it") return it_forms_donatekey_error1(inputs)
	if (locale === "hu") return hu_forms_donatekey_error1(inputs)
	if (locale === "nl") return nl_forms_donatekey_error1(inputs)
	if (locale === "no") return no_forms_donatekey_error1(inputs)
	if (locale === "pl") return pl_forms_donatekey_error1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_donatekey_error1(inputs)
	if (locale === "pt") return pt_forms_donatekey_error1(inputs)
	if (locale === "ro") return ro_forms_donatekey_error1(inputs)
	if (locale === "fi") return fi_forms_donatekey_error1(inputs)
	if (locale === "sv") return sv_forms_donatekey_error1(inputs)
	if (locale === "vi") return vi_forms_donatekey_error1(inputs)
	if (locale === "tr") return tr_forms_donatekey_error1(inputs)
	if (locale === "cs") return cs_forms_donatekey_error1(inputs)
	if (locale === "bg") return bg_forms_donatekey_error1(inputs)
	if (locale === "ru") return ru_forms_donatekey_error1(inputs)
	if (locale === "uk") return uk_forms_donatekey_error1(inputs)
	if (locale === "ar") return ar_forms_donatekey_error1(inputs)
	if (locale === "hi") return hi_forms_donatekey_error1(inputs)
	if (locale === "th") return th_forms_donatekey_error1(inputs)
	if (locale === "ja") return ja_forms_donatekey_error1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_donatekey_error1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_donatekey_error1(inputs)
	return ko_forms_donatekey_error1(inputs)
});
export { forms_donatekey_error1 as "forms.donateKey.error" }